import NewRsmLogo from './NewRsmLogo'

export default NewRsmLogo
